import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS';


const mapStateToProps = (state, ownProps) => ({
    translationStrings: state.getIn(['translation', 'strings', ownProps.id]),
    currentLang: state.getIn(['translation', 'currentLang']),
    debug: state.getIn(['translation', 'debug'])
})


export const translationErrorLog = (debug, msg) => {
    if(debug) {
        console.error('TRANSLATION ERROR: ' + msg)
    }
}

export const getTranslationString = (translationStrings, currentLang) => {
    if(translationStrings && translationStrings.hasOwnProperty(currentLang) && translationStrings[currentLang]) {
        return translationStrings[currentLang]
    } else {
        return false
    }
}

export const getErrorsByTransString = (id, transString, defaultString, currentLang, debug) => {
    if(false === transString) {
        if(defaultString) {
            translationErrorLog(debug, 'No translation for "' + id + '" in ' + currentLang + '. Use defaultString "' + defaultString + '"')

            return defaultString
        } else {
           
            translationErrorLog(debug, 'No translation for "' + id + '" in ' + currentLang + ' and no defaultString')

            return ''
        }
    } else {
        return transString
    }
}

export const TranslationComponent = ({id, currentLang, translationStrings, debug, children, before="", after="", uppercase=false}) => {
    let transString = getTranslationString(translationStrings, currentLang)

    transString = getErrorsByTransString(id, transString, children, currentLang, debug)

    if(before) {
        transString = before + transString
    }

    if(after) {
        transString = transString + after
    }

    if(uppercase) {
        transString = transString.toUpperCase()
    }

    return transString
}

export default compose(
    connect(mapStateToProps, null),
    toJS(),
)(TranslationComponent)
